import Draw from 'ol/interaction/Draw';
import Polygon from 'ol/geom/Polygon';

export function rectangleInteraction() {
  const drawRectangle = new Draw({
    type: 'LineString',
    geometryFunction: (coordinates, geometry) => {
      if (!geometry) {
        geometry = new Polygon([]);
      }
      const start = coordinates[0];
      if (!Array.isArray(start)) {
        throw new Error('Wrong coordinates type');
      }
      const end = coordinates[1];
      if (!Array.isArray(end)) {
        throw new Error('Wrong coordinates type');
      }
      geometry.setCoordinates([[start, [start[0], end[1]], end, [end[0], start[1]], start]]);
      return geometry;
    },
    maxPoints: 2,
    stopClick: true,
  });
  return drawRectangle;
}

export function polygonInteraction() {
  const drawRectangle = new Draw({
    type: 'Polygon',
    stopClick: true,
  });
  return drawRectangle;
}
